import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'

import { EnquireNowForm } from './components/enquireNowForm'
import { ContactForm } from './components/contactForm'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { SubscribeForm } from './components/subscribeForm'

const enquiryForm = document.getElementById('react-enquire-now-form')
if (enquiryForm) {
  ReactDOM.render(
    <React.StrictMode>
      <ToastContainer position="bottom-right" />
      <EnquireNowForm />
    </React.StrictMode>,
    enquiryForm
  )
}

const contactForm = document.getElementById('react-contact-form')
if (contactForm) {
  ReactDOM.render(
    <React.StrictMode>
      <ToastContainer position="bottom-right" />
      <ContactForm />
    </React.StrictMode>,
    contactForm
  )
}

const subscribeForm = document.getElementById('react-subscribe-form')
if (subscribeForm) {
  ReactDOM.render(
    <React.StrictMode>
      <ToastContainer position="bottom-right" />
      <SubscribeForm />
    </React.StrictMode>,
    subscribeForm
  )
}
